export const IntegrationTypes = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large',
  mediumVariation: 'medium-variation',
  largeVariation: 'large-variation'
})
